import React, { useState, useEffect } from "react";
// styles
import "../pages.css";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
import Buttons from '../../components/utils/buttonsContainer/Buttons';
// consts
import { tiposDeDomicilio as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoTiposDeDomicilio as infoModal } from "../../consts/Modals-info";
//Assets
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
//Services 
import { retrieveData } from '../../services/Local-services';
import { tiposDeDomicilioGet } from '../../services/hooli-services/TiposDeDomicilio/TiposDeDomicilioGet';
// recoil
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userCredentials, rowSelected, formData } from '../../recoilState/GlobalState';

export default function TiposDeDomicilio() {
    const [tiposDeDomicilio, setTiposDeDomicilio] = useState([]);
    const [rows, setRows] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [action, setAction] = useState({});

    const setRow = useSetRecoilState(rowSelected)
    const credentials = useRecoilValue(userCredentials);
    const setFormInfo = useSetRecoilState(formData);

    const updateList = async () => {
        setCargando(true);
        await retrieveData(credentials, setRows, tiposDeDomicilioGet, setTiposDeDomicilio)
        setCargando(false);
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) updateList()
    }, [credentials]);

    useEffect(() => {
        tiposDeDomicilio.map((item) => {
            const {
                tipoDeDomicilioId,
                tipoDeDomicilioVersion,
                tipoDeDomicilioNombre,
                tipoDeDomicilioCod,
            } = item

            const tipoDeDomicilio = {
                id: tipoDeDomicilioId,
                version: tipoDeDomicilioVersion,
                [titles[0]]: tipoDeDomicilioNombre,
                [titles[1]]: tipoDeDomicilioCod,
            }

            setRows(rows => [...rows, tipoDeDomicilio])
            return item
        });
    }, [tiposDeDomicilio]);

    useEffect(() => setRow({ status: false }), [])

    const handleClick = ({ action, procede }) => {
        setFormInfo(infoModal[action]);
        setAction({ action, procede });
    };

    return (
        <main className="container">
            <TransitionModal
                titles={titles}
                procede={action.procede}
                updateList={updateList}
            />
            <Buttons texto="tipo de domicilio" handleClick={handleClick} updateList={updateList} />
            <div className="row-grid" >
                {cargando ? <CircularIndeterminate /> : <XGridDemo rows={rows} titles={titles} />}
            </div>
        </main>
    )
};